<!-- Lame 1 Arguments slot -->
<cx-page-slot position="Arguments" />

<!-- Lame 2 Accessory Search -->
<wc-accessory-search [categories]="categories" />

<ng-container>
  <!-- Lame 3 Accessory Categories -->
  <wc-accessory-categories [dataCategories]="subcategories" />

  <!-- Lames de 4 à 9 DynamicBody slot -->
  <cx-page-slot position="DynamicBody" />

  <cx-page-slot position="SEO" />
</ng-container>
